import React, { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, TextField } from "@material-ui/core";
import MemberList from "../Items/MemberList";
import AddActivity from "../Items/AddActivity";
import MainBox from "../Items/MainBox";
import ActivitesList from "../Items/ActivitesList";
import StepDesc from "../Items/StepDesc";

export default function VisitingENGH(props) {
  return (
    <MainBox>
      <MemberList
        groupName={props.states.groupName}
        memberList={props.states.memberList}
      />
      <StepDesc>
        تو این مرحله باید گزارشات مربوط به حضورت تو کلاس های مختلف برای اجرای
        داستان تصویری روایت فتح رو با ما به اشتراک بزاری (هر کلاس رو در یک
        فعالیت جداگانه).
      </StepDesc>
      <div>
        <label>در چند کلاس برای روایت حضور پیدا کردی؟</label>
        <input
          type="text"
          style={{
            width: 45,
            padding: 10,
            marginRight: 10,
            borderRadius: 10,
            outline: "none",
            border: "1px solid #ccc",
            textAlign: "center",
          }}
          maxLength={2}
          placeholder="0"
          onChange={(e) => {
            props.setAns(e.target.value);
          }}
          defaultValue={props.ans}
        />
      </div>
      <AddActivity
        onClick={props.showModal}
        memberList={props.states.memberList}
        ActivityCounts={props.ActivityCounts}
        goForRefresh={props.goForRefresh}
      />
      <ActivitesList
        step={5}
        activities={props.activities}
        stepActs={props.stepActs}
        refresh={props.refresh}
      />
    </MainBox>
  );
}
